(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgms-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tgms-header-navigation')) {
  customElements.define('tgms-header-navigation', class extends HTMLElement {
    connectedCallback() {
      this.onOutsideClick = (event) => {
        if (!this.contains(event.target)) this.closeMenus();
      };
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (!details || !this.contains(details)) return;
        event.preventDefault();
        details.open = false;
        details.querySelector(':scope > summary').focus();
      };
      this.onToggle = (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open || !details.classList.contains('tgms-nav-dropdown')) return;
        const list = details.closest('.tgms-nav-list');
        list.querySelectorAll(':scope > li > details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      };
      this.onLinkClick = (event) => {
        if (event.target.closest('a')) this.closeMenus();
      };
      this.onBreakpoint = () => this.closeMenus();
      this.breakpoint = window.matchMedia('(max-width: 1100px)');
      document.addEventListener('click', this.onOutsideClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('toggle', this.onToggle, true);
      this.addEventListener('click', this.onLinkClick);
      this.breakpoint.addEventListener('change', this.onBreakpoint);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onOutsideClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('toggle', this.onToggle, true);
      this.removeEventListener('click', this.onLinkClick);
      this.breakpoint.removeEventListener('change', this.onBreakpoint);
    }
    closeMenus() {
      this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
